import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'common'}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true, // Required for redirect flow on mobile browsers
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        // Production: disable all console logging
      },
    },
  },
};

// Scopes for Microsoft Graph API
export const graphScopes = {
  loginRequest: {
    scopes: ['User.Read'],
  },
  profileRequest: {
    scopes: ['User.Read', 'profile'],
  },
};

// Scopes for Backend API
export const backendScopes = {
  apiRequest: {
    scopes: [import.meta.env.VITE_BACKEND_SCOPE || 'api://your-backend-scope/.default'],
  },
};
